
<app-user-header></app-user-header>

<div class="container-fluid container-m-t">
    <div class="row">
        <div class="col-sm-3 left-panel-mobile-view">
                <div class="row h-105">
                        <!-- left sidebar -->
                        <div class="col-md-10 fixed pl-0 py-2 left left-sidebar">
                            <ul class="nav flex-md-column flex-nowrap justify-content-center m-l-ipad">
                                <li class="img-circle-styles" style="text-align: center; margin-top: 34px;"><img style="    border: 1px solid #FFF;border-radius: 49%;width: 40%;height: 40%;"
                                        src="assets/images/user-image.png" class="img-circle" alt="Cinque Terre">
                                    <h5 class="center user-text" style="text-align:  center;">
                                        {{ramki.firstName + "  "+ ramki.lastName}}</h5>
                                </li>
                
                                <!-- <li>
                
                                    <a class="nav-link">
                                           <span> Tax Year        </span>           
                                            
                                                <select style="text-align-last:center;" class="form-control select-lag" name="userYear" id="userYear"
                                                    onchange="yearChange()">                                       
                                                    <option value="<?php echo $i;?>"></option>                   
                                                </select>
                                            
                                    </a>
                                    
                                </li> -->
                
                                          
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard">
                                    <a class="nav-link font-size-ipad" routerLink="/dashboard">
                                        <img src="assets/images/dashboard.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Dashboard</span>
                                    </a>
                                </li><br>
                
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Basic Information">
                                    <a class="nav-link font-size-ipad"  routerLink="/basic">
                                        <img src="assets/images/information.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Basic Information</span>
                                    </a>
                                </li><br>
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="My Documents">
                                    <a class="nav-link font-size-ipad"  routerLink="/documents">
                                        <img src="assets/images/doc.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">My Documents</span>
                                    </a>
                                </li><br>
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Download Tax Return">
                                    <a class="nav-link font-size-ipad"  routerLink="/download">
                                        <img src="assets/images/tax.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Download Tax Return</span>
                                    </a>
                                </li><br>
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Make Payment" style="background: black;">
                                    <a class="nav-link font-size-ipad" routerLink="/payment">
                                        <img src="assets/images/payment.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text" style="color: white;">Make A Payment</span>
                                    </a>
                                </li><br>
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Consent Of Disclosure">
                                    <a class="nav-link font-size-ipad" routerLink="/disclosure">
                                        <img src="assets/images/disclosure.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Consent Of Disclosure</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                
                </div>
        </div>
        <!-- <div class="col-sm-1"></div> -->
        <div class="col-sm-9 col-m-t">
            <div class="dash-row">Make A Payment</div>
            <br>
        
            <div>
                <p style="text-align: center;">
                    <img src="assets/images/payment-img.svg">
                </p>
                <h1 style="text-align: center;" class="p-txt-style">Please contact support team of Evolv Tax at <br>
                    <span><a href="tel:+1(888)690-5754" style="color: #ff6d11;"> (888) 690-5754</a>   </span>
                    <br> regarding the payment.
                </h1>
            </div>
        
            <div class="footer" style="text-align: center;background-color: #e9ecef;
                        line-height: 55px; color: black;">
                Copyright ©2020 Evolvtax Services Pvt Ltd. All rights reserved
            </div>
        </div>
    </div>
</div>
